const EDITION_DEMANDE_IMPRESSION = {
  title: {
    add: 'Ajout demande d\'impression',
    edit: 'Modification demande d\'impression',
  },
  breadcrumb: {
    racine: 'Accueil',
    listeDemandeImpression: 'Liste demande d\'impression',
    nouvelleDemandeImpression: 'Ajout demande d\'impression',
    edit: 'Modification demande d\'impression',
  },
  infoGenerale: {
    title: 'Informations générales',
    dateDemande: 'Date demande d\'impression',
    etat: 'Etat',
    couleur: 'Couleur',
    typeOt: 'Type d\'impression ',
    client: 'Client',
    demandeur: 'Contact demandeur',
    receveur: 'Contact receveur',
    dispositif: 'Dispositif',
    campagne: 'Campagne',
    quantite: 'Quantité',
    soldeStock: 'Solde stock',
    nomVariante: 'Nom variante',
    dateLimite: 'Date limite',
    description: 'Description',
    tags: 'Tags',
    nomFichierRip: 'Nom du fichier',
    graphisteEnCharge: 'Graphiste en charge',
  },
  couleurImpression: {
    blanc: 'Blanc',
    jaune: 'Jaune',
    rose: 'Rose',
    bleu: 'Bleu',
  },
  etatDemandeImpression: {
    receptionne: 'Réceptionnée',
    transmisPourImpression: 'Transmis pour impression',
    expedie: 'Expédiée',
    livree: 'Livrée',
    imprimee: 'Imprimée',
    personnalisationMaquette: 'Personnalisation Maquette',
    EnAttenteActionCommerciale: 'En attente action commerciale',
  },
  validation: {
    etat: 'Etat de la demande d\'impression',
    client: 'Client',
    campagne: 'Campagne',
    dateDemande: 'Date de demande',
    dispositif: 'Dispositif',
    societe:
      'la société {societeEmplacement} de l\'emplacement du dispositif est différente de celle de la demande {societeDemande}',
    incorrectDispositif: 'Le dispositf code {code} n\'est pas associé à un emplacement de type \'client\'',
    clientDifferent: 'Le client dans la demande d\'impression est différent de celui sur l\'emplacement du dispositif',
    typeOtMissing: 'Il n\'y a aucun type d\'OT ayant une action d\'intervention de type Impression d\'affiche',
    clientLieuStockage: 'Le client de la demande n\'est pas lieu de stockage',
    foreignKeyConstraint: 'Impossible de supprimer une demande liée à un OT d\'impression',
    typeOt: 'Type d\'impression',
    graphisteEnChargeId: 'Graphiste en charge',
    quantite: 'Quantité',
    nomFichierRip: 'Nom du fichier',
    edition: {
      notEnseigne: 'Edition impossible : le lieu de stockage n\'est pas associé a une enseigne',
    },
  },
  success: {
    demandeAdd: 'Création de la demande d\'impression réalisée avec succès.',
    demandeUpdate: 'Modification de la demande d\'impression réalisée avec succès.',
    impressionEnMasse: 'Demandes d\'impressions générées avec succès.',
  },
  error: {
    demandeAdd: 'Création de la demande d\'impression impossible.',
    demandeUpdate: 'Modification de la Demande d\'impression impossible.',
  },
  popUpDemandeImpresssion: {
    title: 'Impression',
    date: 'Date de la demande',
    campagne: 'Campagne concernée',
    errors: {
      date: 'La date de la demande est obligatoire',
    },
  },
  actions: {
    updateGraphiste: 'Je prends en charge',
    addCampagne: 'Créer une campagne',
  },
};

export default EDITION_DEMANDE_IMPRESSION;
